import type { SVGProps } from 'react';
import React from 'react';

export const ApprovedIcon: React.FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg width={25} height={25} viewBox="0 0 25 25" fill="none" {...props}>
      <circle cx="12.4188" cy="12.8182" r="11.0077" stroke="#56B64E" strokeWidth="2" />
      <path
        d="M7.77344 14.044L10.149 16.4193L13.7493 12.819L17.3496 9.21875"
        stroke="#56B64E"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
